import cx from "classnames"

import { TableComponentTypes } from "./types"

const TableCell = ({ className, children }: TableComponentTypes) => (
  <td className={cx("px-3 py-3  lg:px-5 lg:py-4", className)}>{children}</td>
)

export default TableCell
